import { API_HOST, authenticatedFetchData } from '../lib'
import { sortCampaignsByCharityId } from '../lib/campaign'
import type { HttpError } from '@tomra/client-side-http-client'
import { logError } from '@tomra/datadog-browser-logging'

export function getCharityReportData(appContext: string) {
  try {
    const abortController = new AbortController()

    const run = async () => {
      const [charities, campaignsByCharityId] = await Promise.all([
        fetchAllCharities(abortController, appContext),
        fetchAllCampaigns(abortController, appContext)
      ])

      return charities.map((charity: CharityType) => {
        const latestCampaign = campaignsByCharityId ? campaignsByCharityId?.[charity.id]?.[0] : null

        return {
          charity,
          campaign: latestCampaign
        }
      })
    }

    return {
      run,
      abort: () => {
        abortController.abort()
      }
    }
  } catch (error) {
    if ((error as HttpError).name !== 'AbortError') {
      logError(new Error('Failed to fetch charity report data'), error as Error)
    }

    throw error
  }
}

async function fetchAllCharities(abortController: AbortController, appContext: string) {
  return await authenticatedFetchData(
    `${API_HOST}/charities/admin/v2/summary/${appContext}/charities`,
    {},
    { abortController }
  ).run()
}

async function fetchAllCampaigns(abortController: AbortController, appContext: string) {
  const response = await authenticatedFetchData(
    `${API_HOST}/charities/admin/v2/summary/${appContext}/campaigns`,
    {},
    { abortController }
  ).run()
  return sortCampaignsByCharityId(response)
}
